import { LayersIcon } from '../../components/icons/Icons.tsx';
import { ExpandableSegmentedButtons } from '../../components/segmented-buttons/ExpandableSegmentedButtons.tsx';
import { IWindyLayer } from './WindyMapViewModel.ts';

export const LayerSelector: React.FC<{layer: IWindyLayer, setLayer: (layer: IWindyLayer) => void, segmentStyle?: any}> = ({ layer, setLayer}) => {
    return (
        <ExpandableSegmentedButtons
            options={[{ value: 'wind', label: 'Wind'}, { value: 'rain', label: 'Rain' }]}
            activeValue={layer}
            setActiveValue={value => setLayer(value as IWindyLayer)}
            data-id="wind-or-rain"
            icon={
                <>
                    <LayersIcon size="medium" color="primary" />
                    <span style={{ fontSize: 10, display: 'block', color: 'var(--ion-color-primary)', fontWeight: 'bold' }}>
                        {layer === 'wind' ? 'Wind' : 'Rain'}
                    </span>
                </>
            }
        />
    );
};
